var LocalStorageSupport = function() {};

LocalStorageSupport.prototype.supported = function() {
	try {
		return 'localStorage' in window && window['localStorage'] !== null;
	} catch (e) {
		return false;
	}
};

LocalStorageSupport.prototype.getItem = function(k) {
	if (this.supported()) {
		return window.localStorage.getItem(k);
	} else {
		return null;
	}
};

LocalStorageSupport.prototype.setItem = function(k, v) {
	if (this.supported()) {
		window.localStorage.setItem(k, v);
		this.touch();
	} else {
		return false;
	}
};

LocalStorageSupport.prototype.removeItem = function(k) {
	if (this.supported()) {
		window.localStorage.removeItem(k);
		this.touch();
	}
	return true;
};

LocalStorageSupport.prototype.touch = function() {
	if (this.supported()) {
		window.localStorage.setItem('lastUpdate', new Date());
	}
};

LocalStorageSupport.prototype.cleanUp = function(days, valuesToRemove) {
	var dt = new Date();
	var lastUpdate = new Date(this.getItem('lastUpdate'));
	if (dt-lastUpdate > days*24*3600*1000) {
		for (var i=0; i<valuesToRemove.length; i++) {
			this.removeItem(valuesToRemove[i]);
		}
	}
};

module.exports = LocalStorageSupport;



// WEBPACK FOOTER //
// ./fe/web-default/src/js/web/LocalStorageSupport.js